import { useState } from 'react';
import { Container } from '@mui/material';
import GatewayTable from '../components/Gateway/GatewayTable';
import GatewayDetail from '../components/Gateway/GatewayDetail';

function GatewayPage() {
    const [selectedGatewayId, setSelectedGatewayId] = useState(null);

    if (selectedGatewayId) {
        return (
            <GatewayDetail
                gatewayId={selectedGatewayId}
                onBack={() => setSelectedGatewayId(null)}
            />
        );
    }

    return (
        <Container maxWidth="xl" sx={{ mt: 4 }}>
            <GatewayTable onSelect={setSelectedGatewayId} />
        </Container>
    );
}

export default GatewayPage;
